import type { RouteRecordRaw } from 'vue-router';

import { setToken, autoLogin, logout } from '@/api/user';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/login/index.vue'),
  },
  {
    path: '/template',
    component: () => import('@/views/template/index.vue'),
  },
  {
    path: '/synthesize',
    component: () => import('@/views/synthesize/index.vue'),
  },
];

export default routes;
